import { Label } from "../Label";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
export const FormLabel = props => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('Deprecation warning: The `FormLabel` has been renamed to `Label`. The `FormLabel` export will be removed in a future version of the design system.');
  }
  return /*#__PURE__*/_jsx(Label, {
    ...props
  });
};